module.exports = __webpack_public_path__ + "static/media/GLASS.67fad1f1.svg";